import React from "react";
import LeaflogixAccount from "../../LeaflogixAccount";
import {ROUTES_INTEGRATIONS_LEAFLOGIX_LIST} from "../../../../utils/Constants";
import {useSelector, useDispatch} from "react-redux";
import {selectIntegrationAccounts} from "../../../../redux/models/integrations/Action";


export const TestDutchieCredentials = ({selectedIntegrationAccounts, formState, setFormState, errors, setErrors, showPassword, setShowPassword, setCreatingAccount}) => {
    const dispatch = useDispatch();

    return <LeaflogixAccount
        create={true}
        enableDelete={false}
        enableEdit={false}
        onDelete={(id) => {}}
        onCreate={(response) => {
            dispatch(selectIntegrationAccounts([...(selectedIntegrationAccounts || []), response]));
        }}
    />
};

export default TestDutchieCredentials;